import { render, staticRenderFns } from "./ShareOK.vue?vue&type=template&id=ac47d652&"
import script from "./ShareOK.vue?vue&type=script&lang=js&"
export * from "./ShareOK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports